/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */

export const DEFAULT_CURRENCY = 'CZK';
export const SUPPORTED_CURRENCIES = ['CZK', 'EUR', 'USD'];
